module.exports = __webpack_public_path__ + "img/2-1.b227dfa6.jpg";